import { Injectable } from '@angular/core';
import { CoverLetter, CoverLetterCreateModel } from "@models/documents/cover-letter";
import BaseApiService from "@shared/services/base/base-api.service";
import { Observable } from "rxjs";

@Injectable()
export class CoverLettersApiService extends BaseApiService {
  loadCoverLetters(): Observable<CoverLetter[]> {
    return this.api.get<CoverLetter[]>(`${ this.apiUrl }/cover-letters/list`);
  }

  loadDefaultCoverLetter(): Observable<string> {
    return this.api.get<string>(`${ this.apiUrl }/cover-letters/default`);
  }

  downloadCoverLetterTemplate(coverLetterId: string, filename: string): Observable<string> {
    return this.api.get<string>(`${ this.apiUrl }/cover-letters/${ coverLetterId }/download`, { params: { filename } });
  }

  testCoverLetter(coverLetterId: string, filename: string): Observable<string> {
    return this.api.get<string>(`${ this.apiUrl }/cover-letters/${ coverLetterId }/cover-letter-test`, { params: { filename } });
  }

  patchCoverLetter(coverLetter: CoverLetter) {
    return this.api.patch<CoverLetter[]>(`${ this.apiUrl }/cover-letters`, coverLetter);
  }

  deleteCoverLetterTemplate(coverLetterId: string): Observable<void> {
    return this.api.delete<void>(`${ this.apiUrl }/cover-letters/${ coverLetterId }`);
  }

  createCoverLetterTemplate(coverLetter: CoverLetterCreateModel): Observable<void> {
    return this.api.post<void>(`${ this.apiUrl }/cover-letters`, coverLetter);
  }

  downloadDefaultTemplate(): Observable<string> {
    return this.api.get<string>(`${ this.apiUrl }/cover-letters/default`);
  }
}
